import React, { useEffect, useState, useCallback } from 'react';
import config from '../../../config/config'
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2'; // Import SweetAlert2

function PropertyList(props) {
  const [property, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getList = useCallback(async () => {
    try {
      setLoading(true);
      const result = await config.contactusFormData();
      setData(result.data || []);
      setError(null);
    } catch (err) {
      setData([]);
      setError(null); // Silently fail
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getList();
  }, [getList]);

  const handleEdit = async (id) => {
    try {
      // SweetAlert2 Confirmation Dialog
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'You want to edit this property!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No',
      });

      if (result.isConfirmed) {
        window.location.href = `editContactUsForm/${id}`;

      }
    } catch (err) {
      // Error message if the API call fails
      Swal.fire('Error!', 'There was an issue editing the property.', 'error');
    }
  };

  const handleRemove = async (id) => {
    try {
      // SweetAlert2 Confirmation Dialog
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this property!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No',
      });

      if (result.isConfirmed) {
        // If the property confirms the action, proceed with the API call
        await config.removeProperty({ 'id': id }); // Call the remove API
        getList(); // Re-fetch property after deletion

        // Success message after API call
        // Swal.fire('Deleted!', 'The property has been deleted successfully.', 'success');
      }
    } catch (err) {
      // Error message if the API call fails
      Swal.fire('Error!', 'There was an issue removing the property.', 'error');
    }
  };

  // const listData = property.map((property, index) => ({ ...property, id: index + 1 }));
  const listData = property.map((property, index) => ({ ...property, serialNo: index + 1 }));
  const columns = [
    { name: '#', selector: row => row._id, sortable: true, width: '60px' },
    { name: 'Name', selector: row => row.name, sortable: true, minWidth: '100px' },
    { name: 'Phone', selector: row => row.phone, minWidth: '100px' },
    { name: 'Email', selector: row => row.email, minWidth: '120px', omit: true },
    { name: 'Country', selector: row => row.country, minWidth: '80px', omit: true },
    { name: 'State', selector: row => row.state, minWidth: '80px', omit: true },
    { name: 'Pincode', selector: row => row.pincode, minWidth: '80px', omit: true },
    { name: 'Address', selector: row => row.address, minWidth: '120px', omit: true },
    {
      name: 'Actions',
      button: true,
      width: '100px',
      cell: row => (
        <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
          <button
            onClick={() => handleEdit(row._id)}
            className="btn btn-warning btn-sm"
            style={{ padding: '0.25rem 0.5rem', fontSize: '11px' }}
          >
            View
          </button>
        </div>
      ),
    },
  ];

  const paginationOptions = {
    rowsPerPageText: 'Rows per page:',
    rangeSeparatorText: 'of',
    selectAllRowsItem: true,
    selectAllRowsItemText: 'All',
  };

  const customStyles = {
    headCells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
        fontSize: '13px',
        fontWeight: '600',
      },
    },
    cells: {
      style: {
        paddingLeft: '8px',
        paddingRight: '8px',
        fontSize: '12px',
      },
    },
  };

  return (
    <div className="page-inner">
      <div className="page-header">
        <h3 className="fw-bold mb-3">Property</h3>
        <ul className="breadcrumbs mb-3">
          <li className="nav-home"><a href="#"><i className="fas fa-home"></i></a></li>
          <li className="separator"><i className="fa-solid fa-greater-than"></i></li>
          <li className="nav-item"><a href="#">Property</a></li>
        </ul>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-header">
              <div className="card-title">
                {/* <a href="/admin/property/addUpdateProperty" className="btn btn-primary">
                  <i className="fas fa-plus"></i> Add
                </a> */}
              </div>
            </div>

            <div className="card-body">
              {loading ? (
                <div>Loading property...</div>
              ) : (
                <DataTable
                  columns={columns}
                  data={listData}
                  pagination
                  paginationComponentOptions={paginationOptions}
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 50]}
                  striped
                  highlightOnHover
                  responsive
                  customStyles={customStyles}
                  noDataComponent={<div style={{padding: '20px'}}>No contacts available</div>}
                />
              )}
            </div>

            <div className="card-action"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PropertyList;
